import { useTranslation } from 'react-i18next';

import { Grid, Typography } from '@mui/material';

import { useCalculateTotal } from '../../../../hooks/useCalculateTotal';
import FormLayoutGenerator, { FieldConfig } from '../../../FormLayoutGenerator';
import { useCalculateSurcharges } from '../hooks/useCalculateSurcharges';

const FIELDS: FieldConfig[] = [
  {
    label: 'holiday_bonus_label',
    name: 'finEHolidaybonusPrc',
    cols: 6,
    inputProps: { min: 0, step: 0.01 }
  },
  {
    label: 'holiday_bonus_label',
    name: 'finEHolidaybonusBuhPrc',
    cols: 6,
    inputProps: { min: 0, step: 0.01 }
  },

  {
    label: 'year_end_bonus_label',
    name: 'finEYearendbonusPrc',
    cols: 6,
    inputProps: { min: 0, step: 0.01 }
  },
  {
    label: 'year_end_bonus_label',
    name: 'finEYearendbonusBuhPrc',
    cols: 6,
    inputProps: { min: 0, step: 0.01 }
  },

  { label: 'total_bonus_label', name: 'totalBonus', disabled: true, cols: 6 },
  {
    label: 'total_bonus_label',
    name: 'totalBonusBuh',
    disabled: true,
    cols: 6
  },

  {
    label: 'k_employers_costs_label',
    name: 'finESalPrc',
    cols: 6,
    inputProps: { min: 0, step: 0.01 }
  },
  {
    label: 'k_employers_costs_label',
    name: 'finESalBuhPrc',
    cols: 6,
    inputProps: { min: 0, step: 0.01 }
  },
  { label: 'total_salary_label', name: 'totalSalary', disabled: true, cols: 6 },
  {
    label: 'total_salary_label',
    name: 'totalSalaryBuh',
    disabled: true,
    cols: 6
  }
];

const SurchargesBonusSection = () => {
  const { t } = useTranslation('common', {
    keyPrefix: 'employerCostSettings.details.surcharges'
  });

  useCalculateTotal(
    ['finEHolidaybonusPrc', 'finEYearendbonusPrc'],
    'totalBonus'
  );

  useCalculateTotal(
    ['finEHolidaybonusBuhPrc', 'finEYearendbonusBuhPrc'],
    'totalBonusBuh'
  );

  useCalculateSurcharges('totalBonus', 'finESalPrc', 'totalSalary');
  useCalculateSurcharges('totalBonusBuh', 'finESalBuhPrc', 'totalSalaryBuh');

  return (
    <>
      <Grid item xs={6}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          {t('work_header')}
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          {t('buh_header')}
        </Typography>
      </Grid>
      <FormLayoutGenerator
        fieldConfigs={FIELDS}
        translateKeyPrefix="employerCostSettings"
      />
    </>
  );
};

export default SurchargesBonusSection;
